export const currency = 'PLN';
